export default __webpack_public_path__ + "static/media/dentadura.e802dd57.png";